"use client";

import { c as _c } from "react/compiler-runtime";
import { Form as FormPrimitive } from "@base-ui/react/form";
function Form(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <FormPrimitive data-slot="form" {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export { Form };